<div class="row mb-5" *ngIf="graphVariables && graphVariables.length>0">
  <mat-radio-group class="flex justify-content-center" aria-label="Select an option" [(ngModel)]="graphType" (ngModelChange)="onSelectGraphType()">
    <mat-radio-button value="line">Line</mat-radio-button>
    <mat-radio-button value="scatter">Scatter</mat-radio-button>
    <mat-radio-button value="profile">Profile</mat-radio-button>
  </mat-radio-group>
</div>
